import { ErrorCodes } from 'enums';

export class TokenNotFoundError extends Error {
  code: ErrorCodes = ErrorCodes.TOKEN_NOT_FOUND;

  constructor() {
    super('Usuário sem acesso a aplicação.');
    this.name = 'TokenNotFoundError';

    return this;
  }
}
